<template>
  <section
    id="cover"
    class="te-bg-webdesign-image relative bg-cover bg-center text-center"
  >
    <div class="co-container-lg relative">
      <div class="te-webdesing-text-content mx-0 flex items-center px-0 pb-5 pt-6 md:mx-5 lg:py-5 xl:mx-0 xl:py-0">
        <div class="w-full md:w-3/5">
          <h1 class="mb-2 flex justify-center tracking-normal md:mb-3">
            <img
              class="block md:hidden"
              src="~/assets/images/Te/TeCourse/Webdesign/Cover/course-name.svg"
              alt="Webデザインコース"
              width="186"
              height="44"
            >
            <img
              class="hidden md:block"
              src="~/assets/images/Te/TeCourse/Webdesign/Cover/course-name-pc.svg"
              alt="Webデザインコース"
              width="204"
              height="48"
            >
          </h1>
          <h2 class="mb-4 font-bold tracking-normal text-co-primary-400 lg:mb-7">
            <span class="te-webdesign-cover-text-sub block">サイトのデザインからバナー実践で</span>
            <span class="te-webdesign-cover-text-big">プロ</span>
            <span class="co-display-7 font-bold">の</span>
            <span class="te-webdesign-cover-text-big">Webデザイナー</span>
            <span class="co-display-7 font-bold">に</span>
          </h2>
          <img
            class="mb-5 inline-block md:hidden"
            src="~/assets/images/Te/TeCourse/Webdesign/Cover/badge-wrap2.png"
            alt="特長"
            style="margin-top: 10.875rem"
            width="351"
            height="114"
          >
          <div class="mb-8 hidden text-center md:block">
            <img
              class="te-webdesign-badge-pc mx-auto"
              src="~/assets/images/Te/TeCourse/Webdesign/Cover/badge-pc-wrap.png"
              alt="特長"
            >
          </div>
          <!-- 251202導線削除 -->
          <!-- <div class="mb-4">
            <a
              href="#apply"
              class="co-btn-primary"
              @click.prevent="scrollTo('apply')"
            >
              今すぐ申し込む
              <FontAwesomeIcon
                :icon="faAngleRight"
                class="fa-fw ml-1 inline h-4 w-5"
              /></a>
          </div> -->
          <!-- 申込締切日 -->
          <!-- 251202導線削除 -->
          <!-- <TeCourseWebdesignCoverTimeSpan :closes-at="closesAt" /> -->
          <div class="alert m-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
            お申し込みを停止しております。 再開の際には改めてご案内いたします。
          </div>
        </div>
        <div class="te-lottie-bg w-full md:w-2/5">
          <img
            src="~/assets/images/Te/TeCourse/Webdesign/Cover/cover-object.svg"
            alt=""
            width="470"
            height="470"
            loading="lazy"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseWebdesignCoverTimeSpan from '~/components/Te/TeCourse/Webdesign/TeCourseWebdesignCoverTimeSpan.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faAngleRight,
    }
  },
  props: {
    closesAt: {
      type: Date,
      default: null,
    },
  },
  components: {
    TeCourseWebdesignCoverTimeSpan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-webdesign-image {
  background-image: url('~/assets/images/Te/TeCourse/Webdesign/Cover/bg-sp.jpg');
  @media (min-width: 768px) {
    background-image: url('~/assets/images/Te/TeCourse/Webdesign/Cover/bg-pc.jpg');
  }
}

.te-webdesing-text-content {
  z-index: 2;
}

/* キャッチコピーサブ */
.te-webdesign-cover-text-sub {
  font-size: 1.25rem;
  @media (min-width: 992px) {
    font-size: 1.75rem;
  }
}

.te-webdesign-cover-text-big {
  font-size: 2rem;
  @media (min-width: 992px) {
    font-size: 2.5rem;
  }
}

.te-webdesign-badge-pc {
  width: 24.0625rem;
  height: 6.25rem;
  @media (min-width: 992px) {
    width: 28.875rem;
    height: 7.5rem;
  }
}

/* lottie */
.te-lottie-bg {
  position: absolute;
  top: 7rem;
  left: 50%;
  z-index: 1;
  width: 15.625rem;
  height: 15.625rem;
  padding: 0;
  margin-left: -125px;
  @media (min-width: 768px) {
    position: static;
    top: 0;
    left: 0;
    width: auto;
    height: auto;
    padding: 0 0.9375rem;
    margin-left: 0;
    background-image: url('~/assets/images/Te/TeCourse/Webdesign/Cover/illust-bg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    img {
      height: 470px;
    }
  }
}

.te-lottie-img-pc {
  width: 14rem;
  height: 14rem;
  @media (min-width: 992px) {
    width: 18.75rem;
    height: 18.75rem;
  }
  @media (min-width: 1200px) {
    width: 31.25rem;
    height: 31.25rem;
  }
}
</style>
